import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlCheckDateFormatResponse extends IIsiDtoPresentationLogicResponse  {
    validFormat?: boolean;
}
export class IsiDtoPlCheckDateFormatResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlCheckDateFormatResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.CheckDateFormat.IsiDtoPlCheckDateFormatResponse, Isilog.IsiComponent.IsiDataTransferObject";
    validFormat?: boolean;

    constructor(data?: IIsiDtoPlCheckDateFormatResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validFormat = _data["validFormat"] !== undefined ? _data["validFormat"] : false;
        }
    }

    static fromJS(data?: IIsiDtoPlCheckDateFormatResponse): IsiDtoPlCheckDateFormatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCheckDateFormatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["validFormat"] = this.validFormat !== undefined ? this.validFormat : false;
        return data;
    }
}
export interface IIsiDtoPlCheckDateFormatRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlCheckDateFormatResponse;
    format?: string;
    value?: string;
}
export class IsiDtoPlCheckDateFormatRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlCheckDateFormatRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.CheckDateFormat.IsiDtoPlCheckDateFormatRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlCheckDateFormatResponse;
    format?: string;
    value?: string;

    constructor(data?: IIsiDtoPlCheckDateFormatRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlCheckDateFormatResponse(data.response) : <IsiDtoPlCheckDateFormatResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlCheckDateFormatResponse.fromJS(_data["response"]) : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlCheckDateFormatRequest): IsiDtoPlCheckDateFormatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCheckDateFormatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}
